export default "__VITE_ASSET__CuAbuUpV__"